import { render, staticRenderFns } from "./unblock.vue?vue&type=template&id=21e47260&"
import script from "./unblock.vue?vue&type=script&lang=js&"
export * from "./unblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports